'use client';

import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { cacheKeys } from '@/shared/lib/cache-invalidation';
import {
  loadingFactsService,
  type LoadingFactItem,
} from '../api/loading-facts.service';

export function useLoadingFacts(projectId: string | undefined) {
  const locale = useLocale();

  return useQuery({
    queryKey: cacheKeys.loadingFacts.byProjectAndLocale(projectId, locale),
    queryFn: async () => {
      if (!projectId) return null;
      return loadingFactsService.getFacts(projectId);
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    // Loading-facts is decor. A stale/deleted projectId returning 404 is not
    // a transient failure to retry — the WebSocket push remains the live
    // refresh path, and the cold-load result is non-essential.
    retry: false,
    refetchOnWindowFocus: false,
  });
}

export type { LoadingFactItem };
